module.exports = __webpack_public_path__ + "assets/img/flag_cover_24h.6f402e53.svg";